import { createSlice, PayloadAction } from '@reduxjs/toolkit';

const initialState = false;

const slice = createSlice({
  name: '$deliveryTimeFetchedEstimateSyncing',
  initialState,
  reducers: {
    setDeliveryTimeFetchedEstimateSyncing(
      state,
      action: PayloadAction<boolean>,
    ) {
      return action.payload;
    },
  },
});

export const { setDeliveryTimeFetchedEstimateSyncing } = slice.actions;
export default slice.reducer;
